import script from "./CitizenLift20SummaryPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./CitizenLift20SummaryPanel.vue?vue&type=script&lang=ts&setup=true"

import "./CitizenLift20SummaryPanel.vue?vue&type=style&index=0&id=3f2bf89c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f2bf89c"]])

export default __exports__